import React from 'react';
import { Combobox, ComboboxOption, ComboboxOptionLabel } from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import copies from '../../copies.json';
import { DmBriefCloseReason } from '../../types';
import { AppI18n, appTranslate } from '../../i18n';
import { CLOSE_MODAL_T_PREFIX } from './constants';

export type Reason = keyof typeof copies.close_brief.close_brief_modal.reasons_combobox.reasons;

interface CloseReasonComboboxProps {
  setCloseReason: (closeReason: DmBriefCloseReason) => void;
}

const translationKeyByReason: Record<DmBriefCloseReason, Reason | null> = {
  [DmBriefCloseReason.PROJECT_CANCELLED]: 'project_cancelled',
  [DmBriefCloseReason.ALREADY_HIRED_BRIEF]: 'hired_for_brief',
  [DmBriefCloseReason.HIRED_ELSEWHERE_IN_FIVERR]: 'hired_elsewhere',
  [DmBriefCloseReason.FREELANCERS_NOT_MET_REQUIREMENTS]: 'no_freelancers_found',
  [DmBriefCloseReason.HIRED_OUTSIDE_FIVERR]: 'hired_through_alternate_source',
  [DmBriefCloseReason.OTHER]: 'other',
  [DmBriefCloseReason.DELETED_BRIEF]: null,
};

export const CloseReasonCombobox = ({ setCloseReason }: CloseReasonComboboxProps) => (
  <Stack direction="column" gap="2">
    <Text fontWeight="semibold">
      <AppI18n k={`${CLOSE_MODAL_T_PREFIX}.reasons_combobox.title`} />
    </Text>
    <Combobox
      placeholder={appTranslate(`${CLOSE_MODAL_T_PREFIX}.reasons_combobox.placeholder`).toString()}
      onChange={(values) => {
        setCloseReason(DmBriefCloseReason[values.item as keyof typeof DmBriefCloseReason]);
      }}
      hideClearButton
      appendToBody
      marginBottom="1"
    >
      {Object.keys(DmBriefCloseReason)
        .filter((reason) => isNaN(Number(reason)))
        .map((reason) => {
          const translationKey = translationKeyByReason[DmBriefCloseReason[reason as keyof typeof DmBriefCloseReason]];
          if (!translationKey) {
            return <></>;
          }

          return (
            <ComboboxOption key={reason} value={reason}>
              <ComboboxOptionLabel>
                {appTranslate(`${CLOSE_MODAL_T_PREFIX}.reasons_combobox.reasons.${translationKey}`).toString()}
              </ComboboxOptionLabel>
            </ComboboxOption>
          );
        })}
    </Combobox>
  </Stack>
);
